export const WITH_SUBLABEL_SPACING = '62px'
export const WITHOUT_SUBLABEL_SPACING = '39px'
